import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';

// Typed version of useDispatch
export const useAppDispatch = () => useDispatch<AppDispatch>();
